export{IconPanelComponent,IconPanelPositions,IconPanelSizes,IconPanelThemes}from"./icon-panel.component.js";
//# sourceMappingURL=index.js.map
